import * as React from 'react';
import { ProductIsSoldOutNote, useProductDetailCtx } from '~shared/segments/ProductDetail';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Renders a note informing that the product is sold out.
 */
export var ProductSoldOutNote = function ProductSoldOutNote() {
  var _useProductDetailCtx = useProductDetailCtx(),
      product = _useProductDetailCtx.product;

  if (product !== null && product !== void 0 && product.isSoldOut) {
    return /*#__PURE__*/_jsx(ProductIsSoldOutNote, {});
  }

  return null;
};